import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@/context/theme-context";
import { Toaster } from "@/components/ui/toaster";
import { Suspense, useEffect } from "react";
import { Mixpanel } from "@/lib/mixpanel";
import { v4 as uuidv4 } from "uuid";
import useAuth from "@/store/use-auth";

const GlobalLayout = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user && user !== null) {
      Mixpanel.identify(user.org_id.toString());
      Mixpanel.people.set({
        $user_id: user.email,
        $name: user.given_name + " " + user.family_name,
        $email: user.email,
        $role: user.role,
      });
    }
  }, [user]);

  useEffect(() => {
    if (!user) {
      const mixpanel_id = localStorage.getItem("mixpanel_id");

      if (mixpanel_id) {
        Mixpanel.identify(mixpanel_id);
        Mixpanel.people.set({
          $distinct_id: mixpanel_id,
        });
      } else {
        const id = "guest_" + uuidv4();
        localStorage.setItem("mixpanel_id", id);
        Mixpanel.identify(id);
        Mixpanel.people.set({
          $distinct_id: id,
        });
      }
    }
  }, [user]);

  return (
    <Suspense fallback={null}>
      <ThemeProvider defaultTheme="light" storageKey="theme">
        <Outlet />
        <Toaster />
      </ThemeProvider>
    </Suspense>
  );
};

export default GlobalLayout;
